namespace Vit {
    export class EntityGrid<TItem,T> extends Serenity.EntityGrid<TItem, EntityGridOptions> {
        constructor(container: JQuery, taskHistoryCorrelationKey?: string) {
            super(container, { taskHistoryCorrelationKey: taskHistoryCorrelationKey });
        }

        protected editItem(entityOrId: any): void {
            if (typeof entityOrId === 'string' || entityOrId instanceof String) {
                this.createEntityDialog(this.getItemType(), dlg => {
                    var dialog = (ss as any).safeCast(dlg, Serenity["IEditDialog"]);

                    if (dialog != null) {
                        dialog.load(entityOrId, () => {
                            dialog.dialogOpen(this.openDialogsAsPanel);
                        });

                        return;
                    }

                    throw new (ss as any).InvalidOperationException(
                        Q.format("{0} doesn't implement IEditDialog!",
                            (ss as any).getTypeFullName((ss as any).getInstanceType(dlg))));
                });
            } else {
                this.createNewEntityDialog(this.getItemType(), dlg => {
                    var dialog = (ss as any).safeCast(dlg, Serenity["IEditDialog"]);

                    if (dialog != null) {
                        dialog.load(entityOrId, () => {
                            dialog.dialogOpen(this.openDialogsAsPanel);
                        });

                        return;
                    }

                    throw new (ss as any).InvalidOperationException(
                        Q.format("{0} doesn't implement IEditDialog!",
                            (ss as any).getTypeFullName((ss as any).getInstanceType(dlg))));
                });
            }
        }

        createNewEntityDialog(itemType: string, callback?: (dlg: Serenity.Widget<any>) => void): Serenity.Widget<any> {
            var dialogClass = this.getNewDialogTypeFor(itemType),
                dialog = Serenity.Widget.create({
                    type: dialogClass,
                    options: this.getDialogOptionsFor(itemType),
                    init: d => {
                        this.initEntityDialog(itemType, d);
                        callback && callback(d);
                    },
                });

            return dialog;
        }

        protected getNewDialogTypeFor(itemType: string): { new(...args: any[]): Serenity.Widget<any> } {
            if (itemType === this.getItemType()) {
                return this.getNewDialogType() || this.getDialogType();
            }

            return Serenity.DialogTypeRegistry.get(itemType) as any;
        }

        protected getNewDialogType() { return null; }

        taskHistoryPrimeryKey: string = "Id";

        protected getColumns() {
            var cols = super.getColumns();

            if (this.options.taskHistoryCorrelationKey) {
                cols.splice(1, 0, {
                    field: 'View   Hhistory',
                    name: '            ',
                    format: ctx => '<a class="inline-action view-details" title="view details"></a>',
                    width: 50,
                    minWidth: 50,
                    maxWidth: 50
                });
            }
            return cols;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            var target = $(e.target);
            var item = this.itemAt(row);


            if (target.hasClass('view-details')) {
                Vit.TaskManager.TaskHistoryDialog.CorrelationID = this.options.taskHistoryCorrelationKey + ":" + item[this.taskHistoryPrimeryKey].toString();
                new Vit.TaskManager.TaskHistoryDialog().dialogOpen();
            }


        }
    }

    interface EntityGridOptions {
        taskHistoryCorrelationKey: string;
    }
}